import { Snowflake, ShieldCheck, Stethoscope, Truck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { IMG } from "@/data/images";
import { Picture } from "@/components/site/Picture";

const ICONS = [Snowflake, ShieldCheck, Stethoscope, Truck];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-forest text-cream py-24 lg:py-32" data-testid="why-us">
      <div className="noise pointer-events-none absolute inset-0 opacity-[0.05]" />
      <Picture
        img={IMG.flockScale}
        alt=""
        className="pointer-events-none absolute inset-y-0 end-0 hidden h-full w-1/3 object-cover opacity-20 lg:block"
        sizes="(min-width: 1024px) 33vw, 0px"
      />
      <div className="absolute inset-y-0 end-0 hidden w-1/3 bg-gradient-to-l from-transparent to-forest lg:block" />

      <div className="container-x relative">
        <div className="mb-16 max-w-2xl">
          <Reveal>
            <p className="eyebrow mb-4 text-gold-light">{t.why.kicker}</p>
          </Reveal>
          <Reveal i={1}>
            <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
              {t.why.title}
            </h2>
          </Reveal>
        </div>

        <RevealGroup className="grid gap-px overflow-hidden rounded-2xl border border-cream/10 bg-cream/10 sm:grid-cols-2">
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <RevealItem
                key={i}
                className="group relative bg-forest p-8 transition-colors duration-500 hover:bg-forest-dark lg:p-10"
                data-testid={`why-item-${i}`}
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-14 w-14 items-center justify-center rounded-xl border border-cream/15 text-gold-light transition-colors duration-500 group-hover:border-gold-light/50">
                    <Icon className="h-7 w-7" strokeWidth={1.6} />
                  </span>
                  <span className="font-display text-4xl font-extrabold text-cream/10">0{i + 1}</span>
                </div>
                <h3 className="mt-8 font-display text-xl font-bold lg:text-2xl">{item.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream/70">{item.d}</p>
              </RevealItem>
            );
          })}
        </RevealGroup>
      </div>
    </section>
  );
};
